module.exports = {
	"apertureWidth": "Öffnungsbreite",
	"apertureLength": "Öffnungslänge",
	"apertureGap1": "Öffnungslücke 1",
	"apertureGap2": "Öffnungslücke 2",
	"ballDiameter": "Kugeldurchmesser",
	"bodyOffset": "Körperversatz",
	"bodyLength": "Körperlänge",
	"bodyDiameter": "Körperdurchmesser",
	"bodyHeight": "Körperhöhe",
	"bodyColor": "Körperfarbe",
	"componentFamily": "Komponentenfamilie",
	"colPitch": "Spaltenabstand",
	"chipArrayNote": "* L1 und b1 sind optional.",
	"crystalNote": "* Wählen Sie eine optionale Bemaßung von (D, D2, L) aus. Verschiedene Kombinationen können unterschiedliche Footprint-Pad-Größen erzeugen.",	
	"densityLevel": "Dichtestufe",	
	"femaleStandoffNote": "* Das Montagebohrungs-Pad ist optional und kann durch Eingabe der in der linken Abbildung dargestellten Werte für die Bemaßungen generiert werden. Der Bohrungsdurchmesser (b) wird für die Erstellung der Montagebohrung und für das mechanische Abstandshaltermodell ohne Innengewinde verwendet.",
	"footprintOrigin": "Footprint-Ursprung",
	"hPinPitch": "Horizontaler Pin-Abstand",
	"hTerminalGap": "Lücke horizontale Klemme",
	"hTerminalTailLength": "Länge bei Ende für horizontale Klemme",
	"innerThreadDepth": "Tiefe Innengewinde",
	"innerThreadSize": "Größe Innengewinde",
	"innerThreadDesignation": "Bezeichnung Innengewinde",
	"leadDiameter": "Leitungsdurchmesser",
	"leadSpan": "Leitungsspanne",
	"leadSpan1": "Leitungsspanne 1",
	"leadSpan2": "Leitungsspanne 2",
	"leadShape": "Leitungsform",
	"largerTerminalLength": "Länge größere Klemme",
	"largerTerminalWidth": "Breite größere Klemme",
	"maleFemaleStandoffNote": "* Das Montagebohrungs-Pad ist optional und kann durch Eingabe der in der linken Abbildung dargestellten Werte für die Bemaßungen generiert werden. Der Bohrungsdurchmesser (b) wird für die Erstellung der Montagebohrung verwendet.",
	"mapSilkscreen": "Siebdruck dem Körper zuordnen",
	"optionalDimensionNote": "* Wählen Sie eine optionale Bemaßung von (D, D2, L) aus. Verschiedene Kombinationen können unterschiedliche Footprint-Pad-Größen erzeugen.",
	"oddTerminalLength": "Länge ungerade Klemme",
	"oddTerminalWidth": "Breite ungerade Klemme",
	"optionalDimension": "Optionale Bemaßung",	
	"partialThread": "Teilgewinde",	
	"pasteCoverage": "Überdeckung einfügen",
	"producibilityLevel": "Produzierbarkeitsebene",
	"pinPitch": "Pin-Abstand",
	"padToHoleRatio": "Verhältnis Pad zu Bohrung",
	"padRoundness": "Rundheit des Pads",
	"pinNumbering": "Pin-Nummerierung",
	"postLength": "Stiftlänge",
	"postThreadSize": "Größe Stiftgewinde",
	"postThreadDesignation": "Bezeichnung Stiftgewinde",
	"rowPitch": "Zeilenabstand",
	"tabWidth": "Haltesteg-Breite",
	"tabLength": "Haltesteg-Länge",
	"terminalThickness": "Klemmenstärke",
	"terminalWidth": "Klemmenbreite",
	"terminalLength": "Klemmenlänge",
	"terminalGap": "Klemmenlücke",
	"terminalCCGap": "Klemmenmitte - Achsabstand",
	"terminalCCGap1": "Klemmenmitte - Achsabstand 1",
	"terminalCCGap2": "Klemmenmitte - Achsabstand 2",
	"terminalTailLength": "Klemmenendlänge",
	"terminalPostLength": "Länge Anschlussstift",
	"terminalType": "Klemmentyp",	
	"threadDepth": "Gewindetiefe",
	"threadSize": "Gewindegröße",
	"threadDesignation": "Gewindebezeichnung",	
	"threaded": "Mit Gewinde",
	"truncateMiddlePin": "Mittleren Pin kürzen",		
	"vPinPitch": "Vertikaler Pin-Abstand",
	"vTerminalGap": "Lücke vertikale Klemme",
	"vTerminalTailLength": "Endlänge vertikale Klemme",
	"#Rows": "Anz. Zeilen",
	"#Cols": "Anz. Spalten",
	"#Pins": "Anz. Pins",
	"#DPins": "Anz. Pins (Seite D)",
	"#EPins": "Anz. Pins (Seite E)",
	"padShape": "Pad-Form",
	"RESISTOR": "Widerstand",
	"NONPOLARIZED_CAPACITOR": "Kondensator - nicht polarisiert",
	"POLARIZED_CAPACITOR": "Polarisierter Kondensator",
	"DIODE": "Diode",
	"FUSE": "Sicherung",
	"INDUCTOR": "Induktor",
	"POLARIZED_INDUCTOR": "Polarisierter Induktor",
	"NONPOLARIZED_INDUCTOR": "Induktor - nicht polarisiert",
	"LRCCW": "Entgegen dem Uhrzeigersinn von unten links",
	"LRCW": "Im Uhrzeigersinn von oben links",
	"ZZBT": "Zickzack von unten links",
	"PIN_ONE": "Pin 1",
	"CENTER_PADS": "Mitte der Pads",
	"female": "Aufnahmestück",
	"male": "Stecker",
	"maleFemale": "Stecker/Aufnahmestück",
	"ROUND": "Rund",
	"HEX": "Sechskant",
	"SQUARE": "Quadratisch",
	"Round": "Rund",
	"Square": "Quadratisch",
	"RoundedSquare": "Abgerundetes Quadrat",
	"Rectangle": "Rechteck",
	"Black": "Schwarz",
	"Green": "Grün",
	"Blue": "Blau",
	"Yellow": "Gelb",
	"Amber": "Bernsteinfarben",
	"Brown": "Braun",
	"Cyan": "Cyan",
	"Maroon": "Kastanienbraun",
	"Grey": "Grau",
	"Silver": "Silber",
	"Purple": "Violett",
	"Red": "Rot",
	"White": "Weiß",
	"Most (A)": "Max. (A)",
	"Nominal (B)": "Nominal (B)",
	"Least (C)": "Min. (C)",
	"Most (M)": "Max. (M)",
	"Nominal (N)": "Nominal (N)",
	"Least (L)": "Min. (L)",
	"IC": "Integrierter Schaltkreis (IC)",
	"PRECISION_INDUCTOR": "Präzisionsinduktor",
	"LED": "LED",
	"THERMISTOR": "Thermistor",
	"POLARIZED_DIODE": "Diode",
	"VARISTOR": "Varistor",
	"FERRITE_BEAD": "Ferritperle",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "Chip",
	"SOD": "SOD",
	"MOLDED_BODY": "Formen, generisch",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "E-Cap",
	"CRYSTAL": "Quarz",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "Chip Array, 2-seitig flach/konkav",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "Chip Array, 4-seitig flach/konkav",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "Chip Array, 2-seitig konvex",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "Oszillator, Ecken konkav",
	"OSCILLATOR_J_LEAD": "Oszillator, Anschluss J-Form",
	"OSCILLATOR_L_BEND": "Oszillator, Anschluss L-Form",
	"SOJ": "SOJ",
	"AXIAL": "Axial",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "Steckerleiste, gerade",
	"PIN_HEADER_RA": "Steckerleiste, abgewinkelt",
	"RECEPTACLE_HEADER_STRAIGHT": "Buchsenleiste, gerade",
	"RECEPTACLE_HEADER_RA": "Buchsenleiste, abgewinkelt",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "Radial generisch (rund)",
	"RADIAL_LED": "Radiale LED (rund)",
	"CRYSTAL_HC49": "Quarz (HC49)",
	"FEMALE_STANDOFF": "Abstandshalter, Innengewinde durchgehend",
	"MALE_FEMALE_STANDOFF": "Abstandshalter, Außen-/Innengewinde",
	"SNAP_LOCK": "Halter, Schnappverbindung",
	"Optional_D": "D (Leitungsspanne)",
	"Optional_D2": "D2 (Klemmenlücke)",
	"Optional_L": "L (Klemmenlänge)",
	"CONCAVE": "Konkav",
	"FLAT": "Flach",
	"Oblong": "Länglich",
	"Collapsing_Ball": "Zusammendrückbare Kugel",
	"Non_Collapsing_Ball": "Nicht zusammendrückbare Kugel",
	"mountingHolePad": "Montagebohrungs-Pad",
	"withVias": "Mit Vias",
	"viasCount": "Via-Anzahl",
	"viaDiameter": "Via-Durchmesser",
	"viaOffset": "Via-Versatz von Bohrungsmittelpunkt",
	"viaThermalRelief": "Via-Wärmeentlastung",
	"radialLedNote": "* c gilt nicht für die abgerundete Leitungsform.",
	"lockHeight": "Sperrhöhe",
	"overrideLockDiameter": "Sperrdurchmesser überschreiben",
	"lockDiameter": "Sperrdurchmesser",
	"overridePitch": "Pin-Abstand überschreiben",
	"bodyWidth": "Körperbreite",
	"padWidth": "Pad-Breite",
	"plated": "Plattiert",
	"ViaOffset": "Via-Versatz von Bohrungsmittelpunkt",
	"holeDiameter": "Bohrungsdurchmesser",
	"snapLockNote1": "* Der Sperrdurchmesser (E1) wird automatisch basierend auf dem Körperdurchmesser (E) und dem Bohrungsdurchmesser (b) berechnet. Sie können jedoch benutzerdefinierte Werte angeben, indem Sie den Sperrdurchmesser überschreiben.",
	"snapLockNote2": "* Bohrungsdurchmesser (b) darf nicht mit Körperdurchmesser (E) und Sperrdurchmesser (E1) übereinstimmen",
	"leadWidth": "Leitungsbreite",
	"leadThickness": "Leitungsstärke",
	"boardThickness": "Leiterplattenstärke",
	"error1": "Nicht implementiert.",
	"fabricationTolerance": "Fertigungstoleranz", 
	"placementTolerance": "Platzierungstoleranz",
	"CAPACITOR": "Kondensator - nicht polarisiert",
	"CAPACITOR_NONPOLARIZED": "Kondensator - nicht polarisiert",
	"CAPACITOR_NON_POLARIZED": "Kondensator - nicht polarisiert",
	"FILTER": "Filter", 
	"TRANSISTOR": "Transistor",
	"ecapNote": "* Wählen Sie eine optionale Bemaßung von (D, D2, L) aus. Verschiedene Kombinationen können unterschiedliche Footprint-Pad-Größen erzeugen.",
	"maximum": "Maximum", 
	"nominal": "Nominal", 
	"minimum": "Minimum",
	"bodyShape": "Körperform",
	"customSolderPaste": "Benutzerdefinierte Lötpaste",
	"thermalPad": "Wärmeleitpad",
	"thermalPadLength": "Länge Wärmeleitpad",
	"thermalPadWidth": "Breite Wärmeleitpad",
	"RoundedRectangle": "Abgerundetes Rechteck",
	"extendedEdgeLength": "Erweiterte Kantenlänge",
	"Generator": " Generator",
	"axialNote": "* Der Pin-Abstand wird automatisch basierend auf der Größe des Körpers, der Klemme und der Produzierbarkeitsebene berechnet, um die IPC-Konformität des Footprints zu gewährleisten. Sie können jedoch benutzerdefinierte Werte angeben, indem Sie den Pin-Abstand überschreiben, um einen nicht IPC-konformen Footprint zu erstellen.",
	"baseHeight": "Basishöhe",
	"CHIP_LED": "Chip-LED",
	"updatePreview": "Vorschau aktualisieren",
	"Custom": "Benutzerdefiniert",
	"ledColorNote": "* Geben Sie für die benutzerdefinierte Körperfarbe Hexadezimalwert ein.",
	"customBodyColor": "Benutzerdefinierte Körperfarbe",							
	"lensShape": "Objektivform",
	"domeDiameter": "Kuppeldurchmesser",
	"RECT_FLAT_TOP": "Rechteck mit flacher Oberseite",
	"RECT_DOMED_TOP": "Rechteck mit gewölbter Oberseite",
	'customFootprint': 'Benutzerdefinierter Footprint',
	'customPadLength': 'Benutzerdefinierte Pad-Länge',
	'customPadWidth': 'Benutzerdefinierte Pad-Breite',
	'customPadGap': 'Benutzerdefinierter Abstand zwischen Pads',
	'customOddPadWidth': 'Benutzerdefinierte Pad-Breite (ungerade)',
	'customOddPadLength': 'Benutzerdefinierte Pad-Länge (ungerade)',
	'customPadDiameter': 'Benutzerdefinierter Pad-Durchmesser',
	'customPadSpan1': 'Benutzerdefinierte Pad-Spanne 1',
	'customPadSpan2' : 'Benutzerdefinierte Pad-Spanne 2',
	'customPadPitch' : 'Benutzerdefinierter Pad-Abstand',
	'pinPitch1' : 'Pin-Abstand 1',
	'customPadGap1': 'Benutzerdefinierter Pad-zu-Pad-Abstand 1',
	'Optional_g': 'g (Benutzerdefinierter Pad-Abstand)',
	'Optional_p': 'p (Benutzerdefinierte Pad-Steigung)',

	// JS Widgets
	"New_Library": "Neue Bibliothek",
	"Components": "Komponenten",
	"Component": "Komponente",
	"Symbols": "Symbole",
	"Symbol": "Symbol",
	"Footprints": "Footprints",
	"Footprint": "Footprint",
	"Packages": "Packages",
	"Package": "Package",
	"No": "Nein",
	"Name": "Name",
	"Pins": "Pins",
	"Pads": "Pads",
	"Description": "Beschreibung",
	"Variants": "Varianten",
	"Type": "Typ",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "Library.io-URN",
	"Library_io_Version": "Library.io-Version",
	"Link": "Verknüpfung",
	"Rename": 'Umbenennen',
	"Edit_Description": 'Beschreibung bearbeiten',
	"Duplicate": 'Duplizieren', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": 'Neues 3D-Modell erstellen',
	"Attach_Copy_Existing_3D_Model": 'Kopie des vorhandenen 3D-Modells zuordnen',
	"Edit": 'Bearbeiten',
	"Delete": 'Löschen',
	"Remove_From": 'Entfernen aus',
	"Update_To_Latest": 'Auf neueste Version aktualisieren',
	"Create_New_Symbol": 'Neues Symbol erstellen',
	"Create_New_Footprint": 'Neuen Footprint erstellen',
	"Create_New_Component": 'Neue Komponente erstellen',
	"Create_New_Package": 'Neues Package erstellen',
	"Delete_Package_Children_Warning": "Dadurch werden auch die Packages gelöscht, die von diesem Footprint verwendet werden.",
	"No_Search_Results": "Keine Suchergebnisse",
	"No_Library_Loaded": "Bibliothek nicht geladen",
	"Library_Stored_Fusion_Hub": "Diese Bibliothek wird in your Fusion Hub gespeichert.",
	"Library_Linked_Managed_Library": "Diese Bibliothek ist mit einer verwalteten Library.io-Bibliothek verknüpft.",
	"Library_Local_Changes": "Diese Bibliothek enthält Änderungen, die noch nicht an Library.io gesendet wurden. Wechseln Sie dazu zum Werkzeugkasten Verwalten.",
	"Library_Remote_Changes": "Diese Bibliothek enthält neue Aktualisierungen, die aus Library.io abgerufen werden können. Wechseln Sie dazu zum Werkzeugkasten Verwalten.",
	"View_on_Library_io": "Auf Library.io anzeigen",
	"Used_In": "Verwendet in",
	"No_Selection": "Keine Auswahl",

	"No_Footprints": "Keine Footprints",
	"No_Symbols": "Keine Symbole",
	"No_Components": "Keine Komponenten",
	"No_Packages": "Keine Packages",

	"Package_Loading_Message": "Bitte warten Sie, während das Package gespeichert und hochgeladen wird.",
	"Attributes": "Attribute",
	"View_Attributes": "Attribute anzeigen",
	"Edit_Attributes": "Attribute anzeigen",
	"Edit_Description": "Beschreibung bearbeiten",
	
	"Use_Placeholder": "Platzhalter verwenden",
	"Placeholder_Message": "Platzhalterform verwenden, wenn dem Footprint kein 3D-Modell zugeordnet ist.",

	"Hub": "Hub",
	"New_Symbol": 'Neues Symbol',
	"New_Footprint": 'Neuer Footprint',
	"New_Component": 'Neue Komponente',
	"New_Package": 'Neues Package',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "Aktualisierung für Package Library.io ist verfügbar. Klicken Sie mit der rechten Maustaste, und wählen Sie Aktualisieren.",
	"Package_Behind_Fusion": "Aktualisierung für Fusion-Package ist verfügbar. Klicken Sie mit der rechten Maustaste, und wählen Sie Aktualisieren.",
	"Package_Behind_Both": "Package-Aktualisierung ist verfügbar. Klicken Sie mit der rechten Maustaste, und wählen Sie Aktualisieren.",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "Die Bibliothek muss aktualisiert werden, bevor Änderungen am Objekt abgerufen werden können. Verwenden Sie zum Aktualisieren der Bibliothek den Werkzeugkasten Verwalten.",
}